import { CountryCode } from "@/data/country-data"

type UserLocaleOptions = {
    path?: string
    countryCode?: string
    hasSeenWrongSitePopup?: boolean
}

export function getUserLocaleClient(): UserLocaleOptions {
    if (typeof document === "undefined") return {}

    const raw = document.cookie
        .split("; ")
        .find(row => row.startsWith("user_locale="))
        ?.split("=")[1]

    if (!raw) return {}

    try {
        return JSON.parse(decodeURIComponent(raw))
    } catch (error) {
        console.error("Failed to parse user_locale cookie:", error)
        return {}
    }
}

export function setUserLocaleClient({
    path,
    countryCode,
    hasSeenWrongSitePopup
}: UserLocaleOptions = {}) {
    if (typeof document === "undefined") return

    let existingData = {}
    const rawCookie = document.cookie
        .split("; ")
        .find(c => c.startsWith("user_locale="))
        ?.split("=")[1]

    try {
        if (rawCookie) {
            existingData = JSON.parse(decodeURIComponent(rawCookie))
        }
    } catch (e) {
        console.info("Invalid existing user_locale cookie, starting fresh.")
    }

    const merged = {
        ...existingData,
        ...(path !== undefined && { path }),
        ...(countryCode !== undefined && { countryCode }),
        ...(hasSeenWrongSitePopup !== undefined && { hasSeenWrongSitePopup })
    }

    document.cookie = `user_locale=${encodeURIComponent(
        JSON.stringify(merged)
    )}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax; Secure`
}

export function removeUserLocaleClient() {
    if (typeof document === "undefined") return

    document.cookie = `user_locale=; path=/; max-age=0; samesite=lax; Secure`
}

export function getUserCountryOriginClient(): CountryCode | null {
    if (typeof document === "undefined") return null

    const raw = document.cookie
        .split("; ")
        .find(row => row.startsWith("user_country_origin=")) // updated to match your cookie name
        ?.split("=")[1]

    if (!raw) return null

    try {
        const parsed = JSON.parse(decodeURIComponent(raw))
        return parsed.countryCode.toUpperCase() ?? null
    } catch (error) {
        console.info("Failed to parse user_country_origin cookie:", error)
        return null
    }
}
